// auth.js
export const login = async (username, password) => {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    });

    if (response.ok) {
        const { token } = await response.json();
        localStorage.setItem('token', token);
        return true;
    }
    return false;
};

export const logout = () => {
    localStorage.removeItem('token');
};

// Utløpt token regnes som utlogget, slik at ProtectedRoute sender til /login
// med en gang i stedet for at API-kallene på siden feiler med 401.
const isExpired = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now();
    } catch {
        return true;
    }
};

// Rent oppslag uten bivirkning (rører ikke localStorage) - trygt å kalle flere
// ganger i samme render uten at svaret endrer seg, bl.a. fordi React
// StrictMode kjører komponentkropper to ganger i utvikling. isAuthenticated()
// under har selve opprydningen; ProtectedRoute bruker denne til i tillegg å
// vite OM det fantes et (nå utløpt) token, til "du ble logget ut"-meldingen.
export const tokenStatus = () => {
    const token = localStorage.getItem('token');
    if (!token) return 'ingen';
    return isExpired(token) ? 'utløpt' : 'gyldig';
};

export const isAuthenticated = () => {
    const status = tokenStatus();
    if (status === 'utløpt') localStorage.removeItem('token');
    return status === 'gyldig';
};

// Hent token fra localStorage og legg det til i headers
export const getToken = () => localStorage.getItem('token');
